<section class="section bg-light" id="services">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <h1 class="section-title text-center">Nuestros Servicios</h1>
                <div class="section-title-border margin-t-20"></div>
                <!-- <p class="section-subtitle text-muted text-center padding-t-30 font-secondary">We craft digital, graphic and dimensional thinking, to create category leading brand experiences that have meaning and add a value for our clients.</p> -->
            </div>
        </div>
        <div class="row margin-t-30">
            <div class="col-lg-4 margin-t-20">
                <div class="services-box">
                    <div class="media">
                        <i class="pe-7s-diamond text-custom"></i>
                        <div class="media-body ml-4">
                            <h4>i. Propiedad </h4>
                            <p class="pt-2 text-muted">Son todos los seguros relacionados con producto, daños materiales y lucro cesante para clientes comerciales o industriales tanto del sector público como del sector privado.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 margin-t-20">
                <div class="services-box">
                    <div class="media">
                        <i class="pe-7s-display2 text-custom"></i>
                        <div class="media-body ml-4">
                            <h4>ii. Beneficios a empleados</h4>
                            <p class="pt-2 text-muted">Seguros que son ofrecidos como parte de los beneficios a los empleados de su empresa.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 margin-t-20">
                <div class="services-box">
                    <div class="media">
                        <i class="pe-7s-piggy text-custom"></i>
                        <div class="media-body ml-4">
                            <h4>iii. Affinity</h4>
                            <p class="pt-2 text-muted">Seguros que son pagados 100% por el usuario final a través de diferentes medios de pago (nómina, cuentas de ahorro, tarjetas de crédito, servicios públicos, etc.).</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 margin-t-20">
                <div class="services-box">
                    <div class="media">
                        <i class="pe-7s-science text-custom"></i>
                        <div class="media-body ml-4">
                            <h4>iv. Reaseguros</h4>
                            <p class="pt-2 text-muted">Ingrese aquí para conocer los servicios relacionados: https://www.willistowerswatson.com/en-GB/Solutions/reinsurance.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 margin-t-20">
                <div class="services-box">
                    <div class="media">
                        <i class="pe-7s-news-paper text-custom"></i>
                        <div class="media-body ml-4">
                            <h4>v. Multilatinas</h4>
                            <p class="pt-2 text-muted">Contamos con un equipo especializado para dar atención a nuestros clientes con presencia en diferentes países.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 margin-t-20">
                <div class="services-box">
                    <div class="media">
                        <i class="pe-7s-plane text-custom"></i>
                        <div class="media-body ml-4">
                            <h4>vi. Consultoría</h4>
                            <p class="pt-2 text-muted">Prestamos servicios de ingeniería de riesgos y consultoría para garantizar que la administración de sus riesgos sea la adecuada.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-lg-4 margin-t-20">
                <div class="services-box">
                    <div class="media">
                        <i class="pe-7s-arc text-custom"></i>
                        <div class="media-body ml-4">
                            <h4>Pixel Perfect Design</h4>
                            <p class="pt-2 text-muted">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 margin-t-20">
                <div class="services-box">
                    <div class="media">
                        <i class="pe-7s-tools text-custom"></i>
                        <div class="media-body ml-4">
                            <h4>Perfect Toolbox</h4>
                            <p class="pt-2 text-muted">Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 margin-t-20">
                <div class="services-box">
                    <div class="media">
                        <i class="pe-7s-timer text-custom"></i>
                        <div class="media-body ml-4">
                            <h4>Awesome Design</h4>
                            <p class="pt-2 text-muted">All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</section>